import API from '@aws-amplify/api';
import { openAIWebRTC } from '@/graphql/mutations';
import Utils from '@/common/utils/utils';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

export const handleAction = async (requestDto) => {
    try {
        let res = await API.graphql({
            query: openAIWebRTC,
            variables: {
                openAIWebRTCRequestDto: requestDto
            },
        });
        let resultData = res.data.openAIWebRTC;
        resultData = {...resultData, data: Utils.convertJSONDataToObject(resultData.data)};
        console.log('[openAIWebRTCService] handleAction result >>>', resultData);
        return resultData;
    } catch (err) {
        console.log('[openAIWebRTCService] handleAction error >>>', err);
        return null;
    }
};

export const createSession = async (corpId, projectId, userId, options = {}) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.OPENAI_WEBRTC_CREATE_SESSION,
        requestBody: JSON.stringify({
            aiOperatorTicketId: options.aiOperatorTicketId,
        }),
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

export const callConnected = async (corpId, projectId, userId, { ticketId, aiOperatorTicketId }) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.OPENAI_WEBRTC_CALL_CONNECTED,
        requestBody: JSON.stringify({ ticketId, aiOperatorTicketId }),
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

export const saveTranscript = async (corpId, projectId, userId, { role, text, chatThreadId, aiOperatorTicketId, ticketId }) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.OPENAI_WEBRTC_SAVE_TRANSCRIPT,
        requestBody: JSON.stringify({ role, text, chatThreadId, aiOperatorTicketId, ticketId }),
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

export const saveRecording = async (corpId, projectId, userId, { filename, s3Key, ticketId }) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.OPENAI_WEBRTC_SAVE_RECORDING,
        requestBody: JSON.stringify({ filename, s3Key, ticketId }),
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

export const endCall = async (
    corpId,
    projectId,
    userId,
    { ticketId, chatThreadId, duration, aiTrainingChatThreadId, aiOperatorTicketId, logSif }
) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.OPENAI_WEBRTC_END_CALL,
        requestBody: JSON.stringify({
            ticketId,
            chatThreadId,
            duration,
            aiTrainingChatThreadId,
            aiOperatorTicketId,
            logSif
        })
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

export const updateHeartbeat = async (corpId, projectId, userId, { ticketId }) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.OPENAI_WEBRTC_UPDATE_HEARTBEAT,
        requestBody: JSON.stringify({ ticketId }),
    };

    const resultData = await handleAction(requestDto);
    return resultData;
};

